import i18n from '../../lang/index'
const slbRouter = [{
  path: '/slb',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'slbindex'
  },
  children: [{
    name: 'slbindex',
    path: 'index',
    component: () => import('@/pages/slb/Index'),
    redirect: {
      name: 'slblist'
    },
    children: [{
      name: 'slblist',
      path: 'instance',
      meta: {
        tab: 'instance',
        title:i18n.t('elb.title'),
      },
      component: () => import('@/pages/slb/SlbInstance'),
    },{
      name: 'certificateList',
      path: 'certificate',
      meta: {
        tab: 'certificate',
        title:i18n.t('elb.navTab.cerM'),
      },
      component: () => import('@/pages/slb/Certificate'),
    },{
      name: 'controlList',
      path: 'control',
      meta: {
        tab: 'control',
        title:i18n.t('elb.navTab.ac'),
      },
      component: () => import('@/pages/slb/AccessControl'),
    }]
  }, {
    name: 'slbdetail',
    path: 'index/instance/detail',
    meta:{
      title:i18n.t('elb.insList.actionsList.manage'),
    },
    component: () => import('@/pages/slb/SlbDetail'),
  }, ]
}]
export default slbRouter



// WEBPACK FOOTER //
// ./src/router/modules/slb.js